import Axios from "axios";
import {
    SET_BUDGET_RELEASE_LIST,
    UNSET_BUDGET_RELEASE_LIST,
} from "@/store/mutation-types";
import { 
    budgetReleaseResource,
} from "@/store/api";

const state = {
    getBudgeReleasetList: [],
};

const getters = {
    getBudgeReleasetList(state) {
        return state.getBudgeReleasetList;
    },
};

const mutations = {
    [SET_BUDGET_RELEASE_LIST](state, data) {
        state.getBudgeReleasetList = data;
    },
    [UNSET_BUDGET_RELEASE_LIST](state) {
        state.getBudgeReleasetList = [];
    },
};

const actions = {
    saveBudgetRelease({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(budgetReleaseResource, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    updateBudgetRelease({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.put(`${budgetReleaseResource}/${data.id}`, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getBudgeReleasetList({ commit }) {
        return new Promise((resolve, reject) => {
        Axios.get(budgetReleaseResource)
            .then(function (response) {
            commit('SET_BUDGET_RELEASE_LIST', response.data.data);
            resolve(response);
            })
            .catch(function (error) {
            commit('UNSET_BUDGET_RELEASE_LIST');
            reject(error);
            });
        });
    },

    getBudgetReleaseById({ commit }, data) {
        const getBudgetReleasRecordById = `${budgetReleaseResource}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getBudgetReleasRecordById)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

